import { Flex, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { UpdateProfileButton } from '@/module/Dashboard/components/UpdateProfileButton';
import { ProfileDetails } from '@/module/Dashboard/model/DashboardTypes';

export interface ProfileInfoProps {
  info: ProfileDetails;
}

export function ProfileInfo({ info }: ProfileInfoProps) {
  const { name, email, jobTitle } = info;

  const { t } = useTranslation();

  return (
    <Stack>
      <Flex justify="space-between">
        <div>
          <Text>Nume: {name}</Text>
          <Text>Email: {email}</Text>
          <Text>Funcție didactică: {t(`jobTitleEnum.${jobTitle}`)}</Text>
        </div>
        <UpdateProfileButton />
      </Flex>
    </Stack>
  );
}
